module.exports = __webpack_public_path__ + "static/6-4399de59ecd80f4f8a5f23e1122ef840.png";